export default __webpack_public_path__ + "static/media/glrc-product.kitchen-basics.13dc8a27.png";